export default "__VITE_ASSET__CldHcIEm__"